import './AgentSuccess.scss'
import { AGENT_SUCCESS_TOUCH_STAGES } from 'common/constants'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { selectAgentSuccessPhoneNumber, selectAgentSuccessPhoneNumberFormatted } from 'manager/selectors/auth'
import { goToLink} from 'common/util/helper'
import { trackAgentSuccessClick } from 'manager/redux/referral'
import { selectManagerOpenUrlFeatureEnabled } from 'manager/selectors/manager_selectors'

export const HIDE_AGENT_SUCCESS_COMPONENT = "hide_agent_success_component"

export const CallAgentSuccess = ({ successPhoneNumber, successPhoneNumberFormatted, onClick, stage }) => (
  <div>
    You can also call us at <span className="AgentSuccess__phone_number" onClick={() => onClick(successPhoneNumber, stage)}>{successPhoneNumberFormatted}</span>. We&apos;re available
    to help Mon-Fri from 8am-5:30pm.
  </div>
)

export const AgentSuccessStage3And4 = ({ stage, successPhoneNumber, successPhoneNumberFormatted, onLinkClick , onCallClick, onHideAgentSuccessClick }) => (
  <div className="AgentSuccess AgentSuccess__stage_3">
    <i className="fa fa-times" onClick={onHideAgentSuccessClick}/>
    <div className="AgentSuccess__stage_3__congrats">
      {stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT && 'Congrats on your first contract!'}
      {stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL && 'Congrats on your first referral!'}
    </div>
    <div className="AgentSuccess__stage_3__help">
        <span className="AgentSuccess__stage_3__help-link"
              onClick={() => onLinkClick({ url: 'https://support.realtor.com/s/article/How-do-I-update-a-referral-s-status', stage })}>
          Click here
        </span> to learn about
      {stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT && ' contract status'}
      {stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL && ' updating status'}
      .
      <CallAgentSuccess
        successPhoneNumber={successPhoneNumber}
        successPhoneNumberFormatted={successPhoneNumberFormatted}
        stage={stage}
        onClick={onCallClick}/>
    </div>
  </div>
)

export const AgentSuccessStage2 = ({ stage, successPhoneNumber, successPhoneNumberFormatted, onLinkClick , onCallClick }) => {
  return (
    <div className="AgentSuccess AgentSuccess__stage_2_container">
      {stage === AGENT_SUCCESS_TOUCH_STAGES.AFTER_FIRST_WEEK  && (
        <div>
          <div className="AgentSuccess__stage_2_title">
            Need help winning referrals?
          </div>
          <div className="AgentSuccess__stage_2_button primary">
            <i className="AgentSuccess__stage_2_play_icon fa fa-play-circle"></i>
            <a onClick={() => onLinkClick({videoUrl: 'https://support.realtor.com/s/how-opcity-works', stage})} rel="noopener noreferrer">
              Tips to Succeed
            </a>
          </div>
        </div>
      )}
      {stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_WEEK && (
        <div>
          <div className="AgentSuccess__stage_2_title">
            Need help with your Referral Manager?
          </div>
        </div>
      )}

      <div className="AgentSuccess__stage_2_button secondary">
        <a onClick={() => onLinkClick({url: 'https://support.realtor.com/s/article/How-do-I-claim-a-referral', stage})} rel="noopener noreferrer">
          View support article
        </a>
      </div>
      <CallAgentSuccess
        successPhoneNumber={successPhoneNumber}
        successPhoneNumberFormatted={successPhoneNumberFormatted}
        stage={stage}
        onClick={onCallClick}/>
    </div>
  )
}

class ReferralAgentSuccessHeader extends Component {

  constructor(props) {
    super(props)
    this.state = {
      hideAgentSuccessComponent: window.localStorage.getItem(props.stage + HIDE_AGENT_SUCCESS_COMPONENT) === 'true',
    }
  }

  trackLinkClick = ({ url, stage, videoUrl }) => {
    const { openUrlFeatureEnabled, trackAgentSuccessClick } = this.props
    trackAgentSuccessClick({stage, url, videoUrl})
    if (url) {
      goToLink(openUrlFeatureEnabled, url)
    }
    if (videoUrl) {
      goToLink(openUrlFeatureEnabled, videoUrl)
    }
  }

  trackCallClick = async (phoneNumber, stage) => {
    const { trackAgentSuccessClick } = this.props
    await trackAgentSuccessClick({ stage, phoneNumber })
    window.location = 'tel:' + phoneNumber
  }

  handleHideAgentSuccessComponent = () => {
    const { stage } = this.props
    window.localStorage.setItem(stage + HIDE_AGENT_SUCCESS_COMPONENT, "true")
    this.setState({
      hideAgentSuccessComponent: true,
    })
  }

  render() {
    const { stage, successPhoneNumberFormatted, successPhoneNumber } = this.props
    const { hideAgentSuccessComponent } = this.state
    if (hideAgentSuccessComponent) {
      return null
    }

    const childProps = {
      stage,
      onLinkClick: this.trackLinkClick,
      onCallClick: this.trackCallClick,
      successPhoneNumber,
      successPhoneNumberFormatted,
    }

    if (stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL || stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT) {
      return <AgentSuccessStage3And4 {...childProps} onHideAgentSuccessClick={this.handleHideAgentSuccessComponent}/>
    } else if (stage === AGENT_SUCCESS_TOUCH_STAGES.AFTER_FIRST_WEEK || stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_WEEK) {
      return <AgentSuccessStage2 {...childProps}/>
    }
  }
}

const selector = createStructuredSelector({
  openUrlFeatureEnabled: selectManagerOpenUrlFeatureEnabled,
  successPhoneNumber: selectAgentSuccessPhoneNumber,
  successPhoneNumberFormatted: selectAgentSuccessPhoneNumberFormatted,
})

const actions = {
  trackAgentSuccessClick,
}

export default connect(selector, actions)(ReferralAgentSuccessHeader)
